import { StopCondition } from '@nemuru-eng/js-api-client';

import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramArrow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramArrow';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramStop } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramStop';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

interface StopConditionDiagramProps {
  stopCondition: StopCondition;
}

// Same four lenders in every option: the 1st fails, the 2nd rejects, the 3rd reviews, the 4th approves.
const ANSWERS = [
  { box: BoxTone.ERROR, text: TextTone.ERROR, tId: 'FAILS' },
  { box: BoxTone.NO, text: TextTone.NO, tId: 'REJECTS' },
  { box: BoxTone.MAYBE, text: TextTone.MAYBE, tId: 'REVIEW' },
  { box: BoxTone.YES, text: TextTone.YES, tId: 'APPROVES' },
];

const STOP_INDEX: Record<StopCondition, number> = {
  [StopCondition.YES]: 3,
  [StopCondition.MAYBE]: 2,
  [StopCondition.NO]: 1,
  [StopCondition.ERROR]: 0,
};

const STEP = 84;

export const StopConditionDiagram = ({ stopCondition }: StopConditionDiagramProps) => {
  const stopIndex = STOP_INDEX[stopCondition];
  const anyResult = stopCondition === StopCondition.ERROR;

  return (
    <Diagram viewBox="0 0 340 80">
      {ANSWERS.map((answer, index) => {
        const x = 6 + index * STEP;
        const consulted = index <= stopIndex;
        const box = !consulted ? BoxTone.GHOST : anyResult ? BoxTone.ANY : answer.box;
        const text = !consulted ? TextTone.MUTED : anyResult ? TextTone.ANY : answer.text;

        return (
          <g key={answer.tId}>
            <DiagramBox x={x} y={22} width={68} tone={box} />
            <DiagramText x={x + 34} y={39} tone={consulted ? TextTone.DEFAULT : TextTone.GHOST}>
              {`${index + 1}ª`}
            </DiagramText>
            <DiagramText
              x={x + 34}
              y={64}
              small
              bold={index === stopIndex}
              tone={text}
              tId={!consulted ? 'NOT_CONSULTED' : anyResult ? 'ANY_RESULT' : answer.tId}
            />
            {consulted && index < stopIndex && <DiagramArrow d={`M${x + 68},35 L${x + 82},35`} />}
          </g>
        );
      })}
      <DiagramStop x={6 + stopIndex * STEP + 76} y={18} />
    </Diagram>
  );
};
